import React from 'react';
import { useMagazinesQuery, useRecentMagazinesQuery, MagazinesItem } from '@framework/content/get-magazines';
import { CardContainer, CardBody, CardItem } from '@/components/ui/card-3d';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Container from '@components/ui-old/container';
import { AnimatedNoContent } from '@components/other/no-content';
interface MagazinesCardProps {
  recent?: boolean;
}
const MagazinesCard: React.FC<MagazinesCardProps> = ({
  recent = false
}) => {
  const {
    t
  } = useTranslation();
  const {
    data,
    error,
    isLoading
  } = recent ? useRecentMagazinesQuery() : useMagazinesQuery();
  if (isLoading) {
    return <div className="text-center py-8"></div>;
  }
  if (error || !data || data.results.length === 0) {
    return <Container>
        <AnimatedNoContent />
      </Container>;
  }
  return <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4" data-sentry-component="MagazinesCard" data-sentry-source-file="magazines-card.tsx">
      {data.results.map((item: MagazinesItem, index: number) => <CardContainer key={`${item.readPath}-${item.downloadPath}-${index}`} className="inter-var">
          <CardBody className="bg-gray-50 relative group/card dark:hover:shadow-2xl dark:hover:shadow-emerald-500/[0.1] dark:bg-black dark:border-white/[0.2] border-black/[0.1] w-auto sm:w-[24rem] h-auto rounded-xl p-4 border">
            <CardItem translateZ="50" className="text-lg font-bold text-neutral-600 dark:text-white">
              {item.title}
            </CardItem>
            <CardItem translateZ="100" className="w-full mt-4">
              <Image src={item.image} height={600} width={600} className="h-62 w-full object-cover rounded-xl group-hover/card:shadow-xl" alt={item.title} />
            </CardItem>
            <div className="flex justify-between items-center mt-8">
              <CardItem translateZ={20} as="a" href={item.readPath || item.image} target="_blank" rel="noopener noreferrer" className="px-3 py-2 rounded-xl bg-green-700 dark:bg-white dark:bg-zinc-950 dark:text-black dark:text-neutral-200 text-white text-xs font-bold">
                📖 {t('common:text-card-read')}
              </CardItem>
              <CardItem translateZ={20} as="a" href={item.downloadPath || item.image} target="_blank" rel="noopener noreferrer" download className="px-3 py-2 rounded-xl bg-black dark:bg-white dark:bg-zinc-950 dark:text-black dark:text-neutral-200 text-white text-xs font-bold">
                ⬇️ {t('common:text-card-download')}
              </CardItem>
            </div>
            <div className="p-4 flex flex-col">
              <p className="text-sm text-neutral-500 mt-1">{t('common:text-card-date')}: {new Date(item.date).toLocaleDateString()}</p>
            </div>
          </CardBody>
        </CardContainer>)}
    </div>;
};
export default MagazinesCard;